import React, { useRef, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import axios from "axios";
import PropTypes from "prop-types";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import NotFound from "@components/Errors/NotFound";
import "./ReportingView.styled.scss";

/**
 * Reporting View
 * Path - /report/dashbaord-uuid
 * @see See [https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3841064981/Reporting+contextual+menu)
 * @component
 */
//404 error if id not exist,dynamic domain


const ReportingView = (props) => {
  const { t } = props;
  const [notFound, setNotFound] = useState(false);
  const dashboardRef = useRef(null);
  const { path } = useParams();

  const dashboards = JSON.parse(
    localStorage.getItem("reportingDashboards") || "[]"
  );
  const dashboard = dashboards.find((item) => item.urlSlug === path);
  const dashboardUuid = dashboard?.uuid;
  
  useEffect(() => {
    let cancelled = false;
    setNotFound(false);
    const loadDashboard = async () => {
      if (!dashboardRef.current) return;

      try {
        const response = await axios.get(
          `/general/reportingDashboards/${dashboardUuid}/embedded`
        );

        const { token, embedUuid } = response.data;

        if (cancelled || !dashboardRef.current) return;

        await embedDashboard({
          id: embedUuid,
          supersetDomain: process.env.REACT_APP_SUPERSET_URL,
          mountPoint: dashboardRef.current,

          fetchGuestToken: async () => token,

          dashboardUiConfig: {
            hideTitle: false,
            hideTab: false,
            hideChartControls: false,
          },
        });
      } catch (error) {
        if (error.response?.status === 404) {
          // Display your existing 404 page.
          setNotFound(true);
        } 
        if (!cancelled) {
          console.error("Failed to embed Superset dashboard:", error);
        }
      }
    };

    loadDashboard();

    return () => {
      cancelled = true;

      if (dashboardRef.current) {
        dashboardRef.current.innerHTML = "";
      }
    };
  }, []);

  if (notFound) {
    return <NotFound />;
  }

  return (
    <section className="superset-dashboard-section">
      <div
        id="superset-dashboard-container"
        ref={dashboardRef}
        style={{
          width: "100%",
          height: "calc(100vh - 20px)",
          minHeight: "600px",
          boxSizing: "border-box",
        }}
      />
    </section>
  );
};

ReportingView.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

ReportingView.defaultProps = {};

export default withTranslation()(ReportingView);
